// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__roNr8","vLegacy":"SelectSecondary_vLegacy__1NBaH","error":"SelectSecondary_error__3V7sL","disabled":"SelectSecondary_disabled__26jER"};